import React, { useState, useEffect, useContext } from "react";
import { withStyles, Paper, MenuItem } from "@material-ui/core";

import { useTranslation } from "react-i18next";
import {
  getParentsRecords,
  getAssociations,
  updateAssociations,
  deleteEntityAssociation,
} from "../../../../API/Entity";
import { getListValues } from "../../../../API/List";
import { CreateAssociationDialog } from "../../../EntityAssociations/Components";
import ModalDialogContext from "../../../../Context/ModalDialog/ModalDialogContext";
import RecordPreview from "../../../SearchRecords/Component/RecordPreview";
import UploadFilesDialog from "../../../EntityDocuments/Components/UploadFilesDialog";
import OwnershipPercentageDialog from "./Component/Connector/ownershipDialog";
import RemoveAssociationDialog from "./Component/Record/removeAssociation";
import Canvas from "./Component/Canvas";
import styles from "./styles";

const OrgStructure = (props) => {
  const {
    classes,
    entity = {},
    user,
    hasRecordPermission,
    hasPermission,
  } = props;

  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [existingAssociations, setExistingAssociations] = useState([]);
  const [allowedAssociations, setAllowedAssociations] = useState([]);

  const [documentDialogOpen, setDocumentDialogOpen] = useState(false);
  const [documentTypes, setDocumentTypes] = useState([]);

  const [percentageDialogOpen, setPercentageDialogOpen] = useState(false);
  const [connector, setConnector] = useState();
  const [currentSourceTotal, setCurrentSourceTotal] = useState();

  const [canRemove, setCanRemove] = useState(false);
  const [removeAssociationOpen, setRemoveAssociationOpen] = useState(false);

  const [selectedRecord, setSelectedRecord] = useState();
  const [selectedRecordChilds, setSelectedRecordChilds] = useState();

  const [reloadSelected, setReloadSelected] = useState(false);
  const [reloadSelectedChilds, setReloadSelectedChilds] = useState(false);

  const [contextMenuVisible, setContextMenuVisible] = useState(false);
  const [contextMenuPosition, setContextMenuPosition] = useState({
    left: 0,
    top: 0,
  });
  const [recordInfoVisible, setRecordInfoVisible] = useState(false);
  const [recordInfoPosition, setRecordInfoPosition] = useState({
    left: 0,
    top: 0,
  });
  const [recordInfo, setRecordInfo] = useState({});
  const [countryList, setCountryList] = useState([]);

  const { showMessage, showErrorMessage, showConfirmation } =
    useContext(ModalDialogContext);
  const { t } = useTranslation();

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const results = await getListValues({ listType: "CL" });
        const { data = [] } = results;
        setCountryList(
          data.map((c) => {
            return { value: c.code, label: c.isoCode3 };
          }),
        );
      } catch (error) {
        console.log("error " + error);
      }
    };

    loadCountries();
  }, []);

  useEffect(() => {
    if (selectedRecordChilds) {
      const wp = selectedRecordChilds.filter(
        (cr) => cr.permissions.canRemoveAssociation,
      );
      setCanRemove(wp.length > 0);
    } else {
      setCanRemove(false);
    }
  }, [selectedRecordChilds]);

  const getParents = async (id) => {
    try {
      const result = await getParentsRecords({
        entityId: id,
      });
      const { data = [] } = result;
      const bos = data.filter((a) => a.associationId === "2");
      return bos;
    } catch (error) {
      showErrorMessage({ error });
    }
  };

  const showRecordMenu = (pos) => {
    setContextMenuPosition(pos);
    setContextMenuVisible(true);
  };

  const hideRecordMenu = () => {
    setContextMenuVisible(false);
  };

  const showRecordInfo = (pos, record) => {
    setRecordInfoPosition(pos);
    const recordInfo = {};
    recordInfo["DUNS number"] = record.dunsNumber;
    recordInfo.address = record.address;
    recordInfo["Full name"] = record.recordName;

    const country = countryList.find(
      (c) => c.value === record.countryOfOperations,
    );
    recordInfo["Country of operations"] = country
      ? country.label
      : record.countryOfOperations;
    recordInfo["JLL unique ID"] = record.mdmId;
    setRecordInfo({ record: recordInfo });
    setRecordInfoVisible(true);
  };

  const hideRecordInfo = () => {
    setRecordInfo({});
    setRecordInfoVisible(false);
  };

  const showAssociationDialog = async () => {
    setContextMenuVisible(false);
    const result = await getAssociations(
      selectedRecord.id,
      selectedRecord.entityCategory,
      null,
    );
    const { data } = result || {};
    const { associations = [], allowedAssociations = [] } = data || {};
    setExistingAssociations(associations);
    setAllowedAssociations(allowedAssociations);
    setIsCreateDialogOpen(true);
  };

  const closAssociationDialog = () => {
    setIsCreateDialogOpen(false);
  };

  const loadDocumentTypes = async () => {
    try {
      const results = await getListValues({ listType: "DT" });
      const { data = [] } = results;
      setDocumentTypes(
        data.map((c) => {
          return { value: c.code, label: c.value };
        }),
      );
    } catch (error) {
      showErrorMessage({ error });
    }
  };

  const showDocumentDialog = async () => {
    await loadDocumentTypes();
    setContextMenuVisible(false);
    setDocumentDialogOpen(true);
  };

  const hideDocumentDialog = () => {
    setDocumentDialogOpen(false);
  };

  const showPercentageDialog = async (connector, currentSourceTotal) => {
    setConnector(connector);
    setCurrentSourceTotal(currentSourceTotal);
    setPercentageDialogOpen(true);
  };

  const hidePercentageDialog = () => {
    setPercentageDialogOpen(false);
  };

  const showRemoveAssociationDialog = async () => {
    setContextMenuVisible(false);
    if (selectedRecordChilds) {
      const wp = selectedRecordChilds.filter(
        (cr) => cr.permissions.canRemoveAssociation,
      );
      if (wp.length > 1) {
        setRemoveAssociationOpen(true);
      } else {
        showConfirmation({
          message: t("messages.record.associations.deleteBeneficialOwner", {
            recordName: selectedRecord.recordName,
            childRecordNames: wp[0].recordName,
          }),
          onPressYes: async (event) => {
            wp.forEach((cr) => (cr.isLoading = true));
            try {
              const result = await deleteEntityAssociation({
                entityId: wp[0].id,
                targetEntityId: selectedRecord.id,
                associationId: "2",
              });
              closAssociationDialog();
              const { message } = result || {};
              showMessage({ message });
              setReloadSelectedChilds(true);
            } catch (e) {
              showErrorMessage({ error: e });
            }
            wp.forEach((cr) => (cr.isLoading = false));
          },
        });
      }
    }
  };

  const hideRemoveAssociationDialog = (status) => {
    setRemoveAssociationOpen(false);
    if (status !== "cancel") {
      setReloadSelectedChilds(true);
    }
  };

  const submitNew = async (newAssociations) => {
    try {
      const {
        targetEntityId,
        targetMdmId,
        targetDnbId,
        associations,
        additionalInformation,
      } = newAssociations;

      await updateAssociations({
        sourceEntityId: selectedRecord.id,
        targetEntityId,
        targetMdmId,
        targetDnbId,
        associations: associations,
        additionalInformation,
      });
      setReloadSelected(true);
      closAssociationDialog();
      showMessage({
        message: t("messages.record.associations.associationsUpdated"),
      });
    } catch (error) {
      showErrorMessage({ error });
    }
  };

  const onLabelUpdate = async () => {
    setReloadSelected(true);
  };

  const onReload = () => {
    setReloadSelected(false);
    setReloadSelectedChilds(false);
  };

  return (
    <div className={classes.pageContent} id="container">
      <Canvas
        entity={entity}
        getParents={getParents}
        reloadSelected={reloadSelected}
        reloadSelectedChilds={reloadSelectedChilds}
        setSelectedRecord={setSelectedRecord}
        setSelectedRecordChilds={setSelectedRecordChilds}
        showRecordMenu={showRecordMenu}
        hideRecordMenu={hideRecordMenu}
        showRecordInfo={showRecordInfo}
        hideRecordInfo={hideRecordInfo}
        showPercentageDialog={showPercentageDialog}
        hidePercentageDialog={hidePercentageDialog}
        onReload={onReload}
        hasRecordPermission={hasRecordPermission}
      />

      {isCreateDialogOpen && (
        <CreateAssociationDialog
          isDialogOpen={isCreateDialogOpen}
          sourceEntityId={selectedRecord.id}
          existingAssociations={existingAssociations}
          allowedAssociations={allowedAssociations}
          user={user}
          onSubmit={submitNew}
          onClose={closAssociationDialog}
          hasPermission={hasPermission}
        />
      )}
      {documentDialogOpen && (
        <UploadFilesDialog
          isDialogOpen={documentDialogOpen}
          documentTypes={documentTypes}
          entityId={selectedRecord.id}
          category={"AML"}
          urn={selectedRecord.urn}
          onClose={hideDocumentDialog}
          onSubmit={hideDocumentDialog}
        />
      )}
      {contextMenuVisible && selectedRecord && (
        <Paper className={classes.menu} style={contextMenuPosition}>
          {selectedRecord.permissions.canAddAssociation && (
            <MenuItem onClick={showAssociationDialog}>
              {t("labels.record.associations.addAssociation")}
            </MenuItem>
          )}
          {selectedRecord.permissions.canAddDocument && (
            <MenuItem onClick={showDocumentDialog}>
              {t("labels.record.documents.addDocument")}
            </MenuItem>
          )}
          {canRemove && (
            <MenuItem onClick={showRemoveAssociationDialog}>
              {t("labels.common.remove")}
            </MenuItem>
          )}
        </Paper>
      )}

      {recordInfoVisible && (
        <Paper className={classes.recordInfo} style={recordInfoPosition}>
          <RecordPreview data={recordInfo} />
        </Paper>
      )}

      {percentageDialogOpen && (
        <OwnershipPercentageDialog
          connector={connector}
          currentSourceTotal={currentSourceTotal}
          isDialogOpen={percentageDialogOpen}
          onClose={hidePercentageDialog}
          onSubmit={hidePercentageDialog}
          onLabelUpdate={onLabelUpdate}
        />
      )}

      {removeAssociationOpen && (
        <RemoveAssociationDialog
          isDialogOpen={removeAssociationOpen}
          record={selectedRecord}
          childRecords={selectedRecordChilds}
          onClose={hideRemoveAssociationDialog}
          onSubmit={hideRemoveAssociationDialog}
        />
      )}
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(OrgStructure);
